module.exports = __webpack_public_path__ + "static/media/Kllect_AppStore-2.af6de53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kllect_AppStore-2.png
// module id = 279
// module chunks = 0